import { render, staticRenderFns } from "./aShop.vue?vue&type=template&id=4bd1b468&scoped=true"
import script from "./aShop.vue?vue&type=script&lang=js"
export * from "./aShop.vue?vue&type=script&lang=js"
import style0 from "./aShop.vue?vue&type=style&index=0&id=4bd1b468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1b468",
  null
  
)

export default component.exports